import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { ActionItemDrawerComponent } from './action-item-drawer.component';

import { ActionItemDrawerData } from './action-item-drawer.helpers';

@Injectable()
export class ActionItemDrawerService {
  constructor(private readonly drawer: NzDrawerService) {}

  openDrawer(data: ActionItemDrawerData, title: string) {
    return this.drawer.create({
      nzBodyStyle: { padding: 0 },
      nzClosable: true,
      nzContent: ActionItemDrawerComponent,
      nzData: data,
      nzMaskClosable: false,
      nzTitle: title,
      nzWidth: '800px',
    });
  }
}
